<app-confirm-action-modal
  testId="pause-campaign-dialog"
  [title]="isPaused ? 'Resume Campaign?' : 'Pause Campaign?'"
  [confirmLabel]="isPaused ? 'Yes, Resume' : 'Yes, Pause'"
  (confirm)="onConfirmPause()"
  (cancel)="onClose()"
>
  <div class="message-content">
    <p *ngIf="!isPaused">
      This will pause the campaign until it is resumed. Are you sure you want to continue?
    </p>
    <p *ngIf="isPaused">
      Resuming the campaign means it will start running again. Do you want to continue?
    </p>
  </div>
</app-confirm-action-modal>
